<template>
  <div>
    <base-header type="gradient-success" class="pb-6">
    </base-header>
    <div class="container">
      <div class="row mt-3">
        <div class="col-3">
          <label>Version de consulta</label>

          <multiselect v-model="versionselect" :options="versions" :searchable="false"
                       :close-on-select="true" :show-labels="false"
                       track-by="id" label="name"
                       placeholder="Seleccionar Version"></multiselect>
        </div>
        <div class="col-4">
          <label>Estado de ordenes para generar los archivos scv</label>
          <!--<base-input addon-left-icon="ni ni-calendar-grid-58">
            <flat-picker slot-scope="{focus, blur}"
                         @on-open="focus"
                         @on-close="blur"
                         :config="config"
                         class="form-control datepicker"
                         v-model="date">
            </flat-picker>
          </base-input>-->
          <multiselect v-model="orderselect" :options="orderstatus" :searchable="false"
                       :close-on-select="true" :show-labels="false"
                       track-by="order_status_id" label="status"
                       placeholder="Seleccionar Estado"></multiselect>
        </div>
        <div class="col-5">
          <base-button class="mt-4" id="search" @click="search">Buscar</base-button>
        </div>
      </div>
      <div class="col-12 row mt-3" v-if="encabezados.length > 0">
        <div class="col-3">
          <!--<download-csv
              style="cursor: pointer;border-radius: 7px;"
              class="btn-default col-12"
              name="Encabezados cotizacion CSI.csv"
              :data="encabezados">
            <span><i class="fa fa-file-excel-o"></i> Descargar Encabezados</span>
          </download-csv>-->
          <vue-excel-xlsx
              style="cursor: pointer;border-radius: 7px;"
              class="btn-default col-12"
              :data="encabezados"
              :columns="columnencabezados"
              :filename="'Encabezados cotizacion CSI'"
              :sheetname="'encabezados'"
          >
            <span><i class="fa fa-file-excel-o"></i> Descargar Encabezados</span>
          </vue-excel-xlsx>
        </div>
        <div class="col-3">
          <i class="fa fa-eye" style="cursor: pointer" @click="viewencabezado = !viewencabezado" aria-hidden="true">Visualizar</i>
        </div>
        <div class="col-3">
          <!--  <download-csv
                style="cursor: pointer;border-radius: 7px;"
                class="btn-default col-12"
                name="Detalles cotizacion CSI.csv"
                :data="detalles">
              <span><i class="fa fa-file-excel-o"></i> Descargar Detalles</span>
            </download-csv>-->
          <vue-excel-xlsx
              style="cursor: pointer;border-radius: 7px;"
              class="btn-default col-12"
              :data="detalles"
              :columns="columndetalle"
              :filename="'Detalles cotizacion CSI'"
              :sheetname="'detalles'"
          >
            <span><i class="fa fa-file-excel-o"></i> Descargar Detalles</span>
          </vue-excel-xlsx>
        </div>
        <div class="col-3">
          <i class="fa fa-eye" style="cursor: pointer" @click="viewedetalle = !viewedetalle" aria-hidden="true">Visualizar</i>
        </div>
      </div>
    </div>
    <div class="col-12 mt-2" v-show="viewencabezado" v-if="encabezados.length > 0">
      <h3>Datos del encabezado </h3>
      <b-table striped hover small="small" responsive :items="encabezados">
      </b-table>
    </div>
    <div class="col-12 mt-2" v-show="viewedetalle" v-if="detalles.length > 0">
      <h3>Datos del detalle </h3>
      <b-table striped hover small="small" responsive :items="detalles">
      </b-table>
    </div>
    <div v-if="noresult === false">
      <h3>No se encontraron resultados a tu consulta</h3>
    </div>
    <div class="content-loading" id="content-loading">
      <div class="img-loading"></div>
    </div>
  </div>
</template>

<script>
import {order_service} from "@/services/order/OrderService";
import {bus} from '@/components/Order/bus-order'
import _ from 'lodash'

export default {
  name: "Movimientos",
  data() {
    return {
      versions: [
        {name: 'Cantidad pedida', id: 1},
        {name: 'Cantidad enviada', id: 2}
      ],
      versionselect: [],
      orderstatus: [],
      orderselect: '',
      date: '',
      mensaje: '',
      encabezados: [],
      viewedetalle: false,
      viewencabezado: false,
      detalles: [],
      noresult: true,
      config: {
        mode: "range",
        enableTime: true,
        dateFormat: "Y-m-d H:i:ss",
        allowInput: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
            longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          },
          months: {
            shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Оct', 'Nov', 'Dic'],
            longhand: ['Enero', 'Febreo', 'Мarzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          },
        }
      },
      columnencabezados: [
        {label: "Fecha Cotización", field: "Fecha Cotización"},
        {label: "Número de Cotización", field: "Número de Cotización"},
        {label: "Fecha de Vigencia", field: "Fecha de Vigencia"},
        {label: "Vigencia En Días", field: "Vigencia En Días"},
        {label: "Concepto Factura", field: "Concepto Factura"},
        {label: "Cliente", field: "Cliente"},
        {label: "Nit Cliente", field: "Nit Cliente"},
        {label: "Nombre Cliente", field: "Nombre Cliente"},
        {label: "Vendedor", field: "Vendedor"},
        {label: "Tipo Mensaje", field: "Tipo Mensaje"},
        {label: "Codigo Mensaje", field: "Codigo Mensaje"},
        {label: "Usuario", field: "Usuario"},
        {label: "Centro de Costo Gene", field: "Centro de Costo Gene"},
        {label: "Lista de Precios", field: "Lista de Precios"},
        {label: "Plazo", field: "Plazo"},
        {label: "Descuento Comercial", field: "Descuento Comercial"},
        {label: "Descuento en Valor", field: "Descuento en Valor"},
        {label: "Base Retención Iva", field: "Base Retención Iva"},
        {label: "Tipo Descuento PPP", field: "Tipo Descuento PPP"},
        {label: "Dirección", field: "Dirección"},
        {label: "Dirección Envío", field: "Dirección Envío"},
        {label: "Transportador", field: "Transportador"},
        {label: "Acarreos", field: "Acarreos"},
        {label: "Tipo Retención en la", field: "Tipo Retención en la"},
        {label: "Tipo Retención Iva A", field: "Tipo Retención Iva A"},
        {label: "Seguros", field: "Seguros"},
        {label: "Tipo Iva Seguros", field: "Tipo Iva Seguros"},
        {label: "Tipo Retención en la  ", field: "Tipo Retención en la  "},
        {label: "Tipo Retención Iva S", field: "Tipo Retención Iva S"},
        {label: "Fletes", field: "Fletes"},
        {label: "Tipo Iva Fletes", field: "Tipo Iva Fletes"},
        {label: "Tipo Retención en la ", field: "Tipo Retención en la "},
        {label: "Tipo Retención Iva F", field: "Tipo Retención Iva F"},
        {label: "Tipo Retención Iva", field: "Tipo Retención Iva"},
        {label: "Documento Referencia", field: "Documento Referencia"},
        {label: "Cantidad Total", field: "Cantidad Total"},
        {label: "Valor Total Cotizaci", field: "Valor Total Cotizaci"},
        {label: "Estado", field: "Estado"},
        {label: "Zona", field: "Zona"},
        {label: "Macrozona", field: "Macrozona"},
        {label: "Canal", field: "Canal"},
        {label: "Sector Dane", field: "Sector Dane"},
        {label: "Forma Pago", field: "Forma Pago"},
        {label: "Impreso", field: "Impreso"},
        {label: "Codigo Origen", field: "Codigo Origen"},
        {label: "Codigo Motivo", field: "Codigo Motivo"},
        {label: "Fecha Ultima Modific", field: "Fecha Ultima Modific"},
        {label: "Aplicacion Origen", field: "Aplicacion Origen"},
        {label: "Fecha Confirmacion", field: "Fecha Confirmacion"},
        {label: "Condicion Pago", field: "Condicion Pago"},
        {label: "Descripcion Cotizaci", field: "Descripcion Cotizaci"},
        {label: "Telefono Envio", field: "Telefono Envio"},
        {label: "Tipo AIU Administrat", field: "Tipo AIU Administrat"},
        {label: "Tipo AIU Imprevistos", field: "Tipo AIU Imprevistos"},
        {label: "Tipo AIU Utilidad", field: "Tipo AIU Utilidad"},
        {label: "IVA AIU", field: "IVA AIU"},
        {label: "AIU Incluido", field: "AIU Incluido"},
        {label: "Tipo Retencion AIU", field: "Tipo Retencion AIU"},
        {label: "Tipo Retencion CREE", field: "Tipo Retencion CREE"},
        {label: "Centro de Costo NIIF", field: "Centro de Costo NIIF"},
        {label: "Tipo Retencion CREE ", field: "Tipo Retencion CREE "}
      ],
      columndetalle: [
        {label: "Número Cotizacion", field: "Número Cotizacion"},
        {label: "Cliente", field: "Cliente"},
        {label: "Bodega", field: "Bodega"},
        {label: "Referencia", field: "Referencia"},
        {label: "Código Barras", field: "Código Barras"},
        {label: "Descripcion Referenc", field: "Descripcion Referenc"},
        {label: "Unidad de Venta", field: "Unidad de Venta"},
        {label: "CANTIDAD COTIZADA", field: "CANTIDAD COTIZADA"},
        {label: "LP del detalle", field: "LP del detalle"},
        {label: "Base Unitaria", field: "Base Unitaria"},
        {label: "Tasa Cambio", field: "Tasa Cambio"},
        {label: "Precio", field: "Precio"},
        {label: "Descuento", field: "Descuento"},
        {label: "Tipo de Iva", field: "Tipo de Iva"},
        {label: "Tipo de Retención", field: "Tipo de Retención"},
        {label: "Descripción Ampliada", field: "Descripción Ampliada"},
        {label: "Fecha de Cierre", field: "Fecha de Cierre"},
        {label: "Número de Fila", field: "Número de Fila"},
        {label: "Centro de costos del", field: "Centro de costos del"},
        {label: "Valor Ipoconsumo", field: "Valor Ipoconsumo"},
        {label: "Valor Estampillas", field: "Valor Estampillas"},
        {label: "Version", field: "Version"},
        {label: "CantidadConfirmada", field: "CantidadConfirmada"},
        {label: "Tipo de Impuesto Con", field: "Tipo de Impuesto Con"},
        {label: "Tipo de Retencion CR", field: "Tipo de Retencion CR"},
        {label: "Centro de costos NII", field: "Centro de costos NII"},
        {label: "Factor de Conversión", field: "Factor de Conversión"},
        {label: "Tipo Retención en la", field: "Tipo Retención en la"},
        {label: "Tipo Retención Iva S", field: "Tipo Retención Iva S"},
        {label: "Fletes", field: "Fletes"},
        {label: "Tipo Iva Fletes", field: "Tipo Iva Fletes"},
        {label: "Tipo Retención en la ", field: "Tipo Retención en la "},
        {label: "Tipo Retención Iva F", field: "Tipo Retención Iva F"},
        {label: "Tipo Retención Iva", field: "Tipo Retención Iva"},
        {label: "Documento Referencia", field: "Documento Referencia"},
        {label: "Cantidad Total", field: "Cantidad Total"},
        {label: "Valor Total Cotizaci", field: "Valor Total Cotizaci"},
        {label: "Estado", field: "Estado"},
        {label: "Zona", field: "Zona"},
        {label: "Macrozona", field: "Macrozona"},
        {label: "Canal", field: "Canal"},
        {label: "Sector Dane", field: "Sector Dane"},
        {label: "Forma Pago", field: "Forma Pago"},
        {label: "Impreso", field: "Impreso"},
        {label: "Codigo Origen", field: "Codigo Origen"},
        {label: "Codigo Motivo", field: "Codigo Motivo"},
        {label: "Fecha Ultima Modific", field: "Fecha Ultima Modific"},
        {label: "Aplicacion Origen", field: "Aplicacion Origen"},
        {label: "Fecha Confirmacion", field: "Fecha Confirmacion"},
        {label: "Condicion Pago", field: "Condicion Pago"},
        {label: "Descripcion Cotizaci", field: "Descripcion Cotizaci"},
        {label: "Telefono Envio", field: "Telefono Envio"},
        {label: "Tipo AIU Administrat", field: "Tipo AIU Administrat"},
        {label: "Tipo AIU Imprevistos", field: "Tipo AIU Imprevistos"},
        {label: "Tipo AIU Utilidad", field: "Tipo AIU Utilidad"},
        {label: "IVA AIU", field: "IVA AIU"},
        {label: "AIU Incluido", field: "AIU Incluido"},
        {label: "Tipo Retencion AIU", field: "Tipo Retencion AIU"},
        {label: "Tipo Retencion CREE", field: "Tipo Retencion CREE"},
        {label: "Centro de Costo NIIF", field: "Centro de Costo NIIF"},
        {label: "Tipo Retencion CREE ", field: "Tipo Retencion CREE "},
      ]
    }
  },
  methods: {
    search: function () {
      //this.date = this.date.split(" to ")
      this.detalles = []
      this.encabezados = []
      if (this.orderselect.order_status_id > 0 || this.versionselect.id >= 1) {
        let data = {
          state: this.orderselect.order_status_id
        }
        document.getElementById("content-loading").classList.add("active");
        if (this.versionselect.id === 1) {
          order_service.GetAllSCIDateV1(data)
        } else {
          order_service.GetAllSCIDate(data)
        }
      }
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
  },
  created() {
    order_service.GetAllOrderStatus()
    bus.$on('GetAllOrderStatus', (response) => {
      this.orderstatus = response
    })
    bus.$on('GetAllSCIDate', (response) => {
          document.getElementById("content-loading").classList.add("inactive");
          if (response.encabezado.length > 0) {
            this.noresult = true

            let index = 1
            let orden = 0
            const encabezado = _.map(response.encabezado, items => {
              if (items['Dirección'] != '' && items['Dirección'][0] === '[') {
                let address = JSON.parse(items['Dirección'])
                items['Dirección'] = address[0].address
                items['Dirección Envío'] = address[0].address
              }

              return items;
            });
            let linea = ''
            const detalle = _.map(response.detalle, items => {
              if (items['Número Cotizacion'] === orden) {
                index += 1
                if (index <= 9) {
                  linea = '0' + index + ''
                } else {
                  linea = index
                }
                items['Número de Fila'] = linea
              } else {

                items['Número de Fila'] = '01'
                index = 1
              }
              orden = items['Número Cotizacion']
              return items;
            });

            this.encabezados = encabezado
            this.detalles = detalle
          } else {
            this.noresult = false
            this.detalles = []
            this.encabezados = []
          }
        }
    )
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.content-loading {
  position: relative;
}
</style>
